import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import * as fromRoot from '..';
import { Search, SearchByMonth, SearchByDay } from '../action/action.actions';

@Injectable()
export class ActionService {
  constructor(
    private store: Store<fromRoot.State>,
  ) {}

  get searchTerm$(): Observable<string> {
    return this.store.select(state => state.action.searchTerm);
  }
  get searchMonth$(): Observable<string> {
    return this.store.select(state => state.action.searchMonth);
  }
  get searchDay$(): Observable<string> {
    return this.store.select(state => state.action.searchDay);
  }

  search(term: string) {
    this.store.dispatch(new Search(term));
  }
  searchByMonth(timestamp: string) {
    this.store.dispatch(new SearchByMonth(timestamp));
  }
  searchByDay(timestamp: string) {
    this.store.dispatch(new SearchByDay(timestamp));
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/store/services/action.service.ts